import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';

import { updateUserSettings } from '../../../actions/Auth';

const FileEmptyFieldsSwitch = ({
  dispatch,
  profile,
  showEmptyFields,
  handleSwitchEmptyFields,
  hideMessage,
  showMessage,
  settingName,
}) => {
  const switchEmptyFields = (e) => {
    e.preventDefault();
    dispatch(updateUserSettings(profile.uuid, { [settingName]: !showEmptyFields }));
    handleSwitchEmptyFields(!showEmptyFields);
  };

  return (
    <Button
      type="button"
      color="link"
      onClick={switchEmptyFields}
      className="file-detail-title file-detail-header-button"
    >
      {showEmptyFields ? (
        <>
          <i className="fal fa-eye-slash" />
          {hideMessage}
        </>
      ) : (
        <>
          <i className="fal fa-eye" />
          {showMessage}
        </>
      )}
    </Button>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
});

FileEmptyFieldsSwitch.propTypes = {
  dispatch: PropTypes.func.isRequired,
  profile: PropTypes.object.isRequired,
  showEmptyFields: PropTypes.bool.isRequired,
  handleSwitchEmptyFields: PropTypes.func.isRequired,
  hideMessage: PropTypes.string.isRequired,
  showMessage: PropTypes.string.isRequired,
  settingName: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(FileEmptyFieldsSwitch);
